export const getCarrierLogo = (carrier: { id: string, hasImage: boolean }) => {
    const logoBucket = "https://axle-labs-assets.s3.amazonaws.com/carrierLogos/";
    return carrier.hasImage
        ? logoBucket + carrier.id + ".svg"
        : logoBucket + "generic.svg";
};